module.exports = __webpack_public_path__ + "img/bulb.40368b5a.svg";